function IconMarker() {
    this.__type = 'IconMaker:www.veritracks.com';
    this.Id = -1;
    this.Url = "";
    this.Index = "";
    this.SVGMarker = "";
    
}
if (typeof exports !== 'undefined') {
    module.exports = IconMarker;
}